import { DateOptions } from 'coreOld/enums';
import { IDateOption } from 'coreOld/types';
import { getPastDate } from 'coreOld/utils';

const today = new Date();
const DEFAULT_START_DATE = '01/01/1900';

export const dateOptions: IDateOption[] = [
  {
    id: 0,
    value: null,
    label: DateOptions.ALL,
  },
  {
    id: 1,
    value: { startDate: today, endDate: today },
    label: DateOptions.TODAY,
  },
  {
    id: 2,
    value: { startDate: getPastDate(1), endDate: getPastDate(1) },
    label: DateOptions.YESTERDAY,
  },
  {
    id: 3,
    value: { startDate: getPastDate(30), endDate: today },
    label: 'Updated in past 30 Days',
  },
  {
    id: 4,
    value: {
      startDate: getPastDate(180),
      endDate: today,
    },
    label: 'Updated in past 180 Days',
  },
  {
    id: 5,
    value: {
      startDate: getPastDate(0, 0, 1),
      endDate: today,
    },
    label: 'Updated in past year',
  },
  {
    id: 6,
    value: {
      startDate: new Date(DEFAULT_START_DATE),
      endDate: getPastDate(30),
    },
    label: 'Not updated in past 30 Days',
  },
  {
    id: 7,
    value: {
      startDate: new Date(DEFAULT_START_DATE),
      endDate: getPastDate(90),
    },
    label: 'Not updated in past 90 Days',
  },
  {
    id: 8,
    value: {
      startDate: new Date(DEFAULT_START_DATE),
      endDate: getPastDate(180),
    },
    label: 'Not updated in past 180 Days',
  },
  {
    id: 9,
    value: {
      startDate: new Date(DEFAULT_START_DATE),
      endDate: getPastDate(0, 0, 1),
    },
    label: 'Not updated in past year',
  },
  {
    id: 10,
    value: null,
    label: DateOptions.CUSTOM_RANGE,
  },
];
